import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../index";
import axios from "axios";
import { getAuthToken } from "../../utils/utils";
// Get clinic sales data
export const getSalesData = createAsyncThunk(
  "sales/getSalesData",
  async (userId, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.post(
        baseUrl + `/clinic-sales/get-data`,
        {
          userId,
        },
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// Update clinic sales data
export const updateSalesData = createAsyncThunk(
  "sales/updateSalesData",
  async (data, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.post(
        baseUrl + `/clinic-sales/update-data`,
        data,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// Add new year
export const addSalesYear = createAsyncThunk(
  "sales/addYear",
  async (userId, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.post(
        baseUrl + `/clinic-sales/add-year`,
        {
          userId,
        },
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// Get All Years Data
export const getSalesYear = createAsyncThunk(
  "sales/getYears",
  async (userId, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.post(
        baseUrl + `/clinic-sales/get-years`,
        {
          userId,
        },
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// Get Selected Years Data
export const getSelectedYearData = createAsyncThunk(
  "sales/getSelectedYears",
  async (data, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.post(
        baseUrl + `/clinic-sales/get-year-data`,
        { ...data },
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
            "Content-Type": "application/json", // Make sure the content type is correct
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const salesSlice = createSlice({
  name: "sales",
  initialState: {
    clinicSales: null,
    years: [],
    getSelectedYearDataItems: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Sales Data
      .addCase(getSalesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSalesData.fulfilled, (state, action) => {
        state.loading = false;
        state.clinicSales = action.payload;
      })
      .addCase(getSalesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Sales Data
      .addCase(updateSalesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSalesData.fulfilled, (state, action) => {
        state.loading = false;
        state.clinicSales = action.payload.updateResult;
      })
      .addCase(updateSalesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add Year
      .addCase(addSalesYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSalesYear.fulfilled, (state, action) => {
        state.loading = false;
        state.clinicSales = action.payload;
      })
      .addCase(addSalesYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Years
      .addCase(getSalesYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSalesYear.fulfilled, (state, action) => {
        state.loading = false;
        state.years = action.payload?.years;
      })
      .addCase(getSalesYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Selected Year Data
      .addCase(getSelectedYearData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSelectedYearData.fulfilled, (state, action) => {
        state.loading = false;
        state.getSelectedYearDataItems = action.payload;
      })
      .addCase(getSelectedYearData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default salesSlice.reducer;
